<template>
  <div class="hlmy">
    <div class="query">
      <van-popover
        v-model="showPopover"
        placement="bottom-start"
        trigger="click"
      >
        <div class="sele-list">
          <p
            v-for="(item, index) in seleList"
            :key="index"
            :class="{ active: num == index }"
            @click="handleList(item, index)"
          >
            <i v-if="num == index" class="iconfont icon-duigou"></i>{{ item }}
          </p>
        </div>
        <template #reference>
          <p class="sele-p">
            {{ p_text
            }}<i
              class="iconfont"
              :class="showPopover ? 'icon-shangsanjiao' : 'icon-xiasanjiao'"
            ></i>
          </p>
        </template>
      </van-popover>
      <div class="btn-box" :class="{ active: isActive }">
        <!-- <div class="btn-bg"></div> -->
        <span :class="{ active: isActive1 }" @click="left()">{{
          gene[0]
        }}</span>
        <span :class="{ active: isActive2 }" @click="right()">{{
          gene[1]
        }}</span>
      </div>
    </div>
    <div class="data-list" v-for="(item, index) in dataList" :key="index">
      <h1>{{ item.geneName }}</h1>
      <div class="show-box"></div>
      <div class="content flex-box">
        <div>
          <p>免疫治疗相关性</p>
          <h2>{{ item.immuneRelated }}</h2>
        </div>
        <div>
          <p>检测结果</p>
          <h2 style="color:#28D4E5">{{ item.detectionResult }}</h2>
        </div>
      </div>
      <div class="content">
        <p>位点解析</p>
        <h2>{{ item.siteAnalysis }}</h2>
      </div>
      <div class="content">
        <p>检测意义</p>
        <h2 v-html="item.detectionMeaningCn"></h2>
      </div>
    </div>
    <Empty v-if="dataList== ''"/>
  </div>
</template>

<script>
import { groupImmuneGene, findImmuneGeneList } from "@/api/wxapi.js";

export default {
  data() {
    return {
      num: 0,
      p_text: "",
      gene: [],
      seleList: [],
      showPopover: false,
      isActive: false,
      isActive1: true,
      isActive2: false,
      dataList: [],
      geneText: "",
    };
  },
  mounted() {
    console.log(this.$route.query.fname);
    this.getCancer();
  },
  methods: {
    getList(cancer, gene) {
      findImmuneGeneList({
        cancer: cancer,
        immuneRelated: gene,
        labOriginalSampleNo: this.$route.query.fname,
        pageNo: 1,
        pageSize: 1,
        productCode: this.$route.query.fid,
      }).then((res) => {
        this.dataList = res.data.records;
      });
    },
    getGene() {
      groupImmuneGene({
        labOriginalSampleNo: this.$route.query.fname,
        pageNo: 1,
        pageSize: 1,
        productCode: this.$route.query.fid,
        tag: 1,
      }).then((res) => {
        this.gene = res.data;
        this.geneText = res.data[0];
        this.getList(this.seleList[0], res.data[0]);
      });
    },
    getCancer() {
      groupImmuneGene({
        labOriginalSampleNo: this.$route.query.fname,
        pageNo: 1,
        pageSize: 1,
        productCode: this.$route.query.fid,
        tag: 0,
      }).then((res) => {
        this.seleList = res.data;
        this.p_text = res.data[0];
        this.getGene();
      });
    },
    handleList(item, index) {
      this.num = index;
      this.p_text = item;
      this.showPopover = false;
      this.getList(this.p_text, this.geneText);
    },
    left() {
      this.getList(this.p_text, this.gene[0]);
      this.geneText = this.gene[0];
      this.isActive = false;
      this.isActive1 = true;
      this.isActive2 = false;
    },
    right() {
      this.getList(this.p_text, this.gene[1]);
      this.geneText = this.gene[1];

      this.isActive = true;
      this.isActive1 = false;
      this.isActive2 = true;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ i{
  font-style: normal;
}
.sele-list {
  padding: 15px 24px 0;
  background: #ffffff;
  .active {
    color: #4b84ff;
  }
  p {
    font-size: 13px;
    font-weight: 400;
    color: #2f354d;
    margin-bottom: 20px;
    i {
      font-size: 14px;
      color: #4b84ff;
      margin-right: 10px;
    }
  }
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(52, 68, 132, 0) 0%,
    rgba(52, 68, 132, 0.1) 100%
  );
  margin-bottom: 10px;
}
.hlmy {
  padding: 16px;
    font-family: @family;

  .data-list {
    background: @background_color;
    border-radius: 10px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    .flex-box {
      display: flex;
    }
    .content {
      padding-left: 24px;
      margin-bottom: 20px;
      div {
        width: 50%;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #a4a9bf;
        margin-bottom: 4px;
      }
      h2 {
        font-size: 13px;
        font-weight: 500;
        color: #2f354d;
        padding-right: 24px;
        word-break: break-all;
        text-align: justify;
        text-justify: newspaper;
      }
    }
    h1 {
      font-size: 18PX;
      font-weight: 500;
      color: #4b84ff;
      line-height: 70px;
      position: relative;
      padding-left: 24px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        width: 3px;
        height: 14px;
        background: #4b84ff;
        border-radius: 0px 2px 2px 0px;
        top: 50%;
        margin-top: -7px;
      }
    }
  }
  .query {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    .sele-p {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4b84ff;
      line-height: 18px;
      i {
        font-size: 10px;
        margin-left: 4px;
      }
    }
    .active {
      &::before {
        transition: right 0.3s;
        right: 0 !important;
      }
    }
    .btn-box {
      width: 140px;
      height: 28px;
      line-height: 28px;
      background: #f4f8fd;
      border-radius: 4px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        transition: right 0.3s;

        right: 50%;
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 2px 6px 0px rgba(52, 68, 132, 0.1);
        border-radius: 4px;
        border: 1px solid #d4d6dd;
      }
      span {
        font-size: 13px;
        color: #9095a7;
        width: 50%;
        display: inline-block;
        text-align: center;
        position: relative;
      }
      .active {
        font-weight: 500;
        color: #2f354d;
      }
    }
  }
}
</style>